import React, { useRef, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useAddNotice } from "../../../../../api/inquiries/notice/use-notice";
import TitlePage from "../../../../../components/section/TitlePage/Titlepage";
import Button from "../../../../../components/ui/Button/Button";
import Modal from "../../../../../components/ui/Modal/Modal";
import Editor from "../../../../../components/Editor";
import FieldBox from "../../../../../utils/Form/ui/FieldBox";

const NoticeRegisterPage = () => {
  const navigate = useNavigate();
  const [title, setTitle] = React.useState("");
  const { mutate: addNotice } = useAddNotice();
  const quillRef = useRef(null);
  const [isContentsEmpty, setIsContentsEmpty] = useState(false);

  const formEmpty = useMemo(() => {
    return title === "" || isContentsEmpty;
  }, [title, isContentsEmpty]);

  const onChangeTitle = (e) => {
    setTitle(e.target.value);
  };
  const handleSubmit = async () => {
    const payload = {
      title: title,
      contents: JSON.stringify(quillRef?.current?.getContents()),
    };
    await addNotice(payload);
  };

  const handleBack = () => {
    navigate("/bulletin-board");
  };

  const onTextChange = (content) => {
    setIsContentsEmpty(quillRef?.current?.getLength() === 1);
  };

  return (
    <>
      <div>
        <TitlePage title="공지사항 > 공지사항 등록" />
        <div className="mt-4">
          <form>
            <FieldBox label="제목">
              <input
                className="rounded-[4px] w-full text-[12px] p-2 focus:outline-none"
                placeholder="제목을 입력해주세요"
                name="title"
                value={title}
                onChange={onChangeTitle}
              />
            </FieldBox>
            <FieldBox isLast label="내용" padding="p-0">
              <Editor ref={quillRef} onTextChange={onTextChange} />
            </FieldBox>
            <div className="flex justify-end mt-4">
              <Modal
                description="입력을 취소하시겠습니까? 입력한 정보는 저장되지 않습니다."
                onSubmit={handleBack}
              >
                <Button width="w-24" text="입력취소" />
              </Modal>
              <Modal
                description="입력을 취소하시겠습니까? 입력한 정보는 저장되지 않습니다."
                onSubmit={handleSubmit}
              >
                <Button
                  width="w-24"
                  onClick={(e) => e.preventDefault()}
                  type="submit"
                  primary
                  text="등록완료"
                  isDisabled={formEmpty}
                />
              </Modal>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default NoticeRegisterPage;
